<template>
  <div class="content jumbotron text-center">

    <img src="../assets/logo.png">

    <!--        <h2>Kontakt</h2>-->

    <p class="lead mt-3">
      Adresse der Praxis:
      <br>
      <a href="https://goo.gl/maps/G7fn7bW5T9Dpk86JA">Rosenheimer Landstr. 72, 85521 Ottobrunn</a>
    </p>
    <p class="lead">
      Telefonnummer:
      <br>
      +49 (089) 95864402
    </p>
    <p>
      <span>telefonische Erreichbarkeit:</span>
      <br>
      Montag 08:00 – 08:30
      <br>
      Donnerstag 12:50 – 14:00
    </p>

    <hr>

    <p class="text-muted">
      In Notfällen wenden Sie sich bitte an:
    </p>
    <div class="row text-muted">
      <div class="col-md-6 col-sm-12">
        Telefonseelsorge: 0800 111011
        <br>
        Kbo Bezirkskrankenhaus Haar: 089/45623400
      </div>
      <div class="col-md-6 col-sm-12">
        Die Arche: 089/334041
        <br>
        Krisentelefon Atriumhaus: 089/76789118
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'ContentContact',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
  min-height: calc(100vh - 60px);
  position: relative;
}

.content a {
  color: inherit;
}

.content img {
  max-height: 20vh;
}
</style>
